var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadgeDe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "32px",
    viewBox: "0 0 108 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "google-play-badge") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "91.488428%",
    y1: "4.9481245%",
    x2: "-38.3517333%",
    y2: "71.9074222%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.684729%",
    y1: "50%",
    x2: "-130.640394%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA500",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.219293%",
    y1: "17.8768889%",
    x2: "-50.1497903%",
    y2: "194.702638%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.7537448%",
    y1: "-54.0521474%",
    x2: "42.1210306%",
    y2: "24.9170664%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "7%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "google-play-badge",
    transform: "translate(-8.000000, -8.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 124,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#000000",
    x: 8,
    y: 8,
    width: 108,
    height: 32,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,8.64 C113.855677,8.64 115.36,10.1443232 115.36,12 L115.36,36 C115.36,37.8556768 113.855677,39.36 112,39.36 L12,39.36 C10.1443232,39.36 8.64,37.8556768 8.64,36 L8.64,12 C8.64,10.1443232 10.1443232,8.64 12,8.64 L112,8.64 L112,8.64 Z M112,8 L12,8 C9.790861,8 8,9.790861 8,12 L8,36 C8,38.209139 9.790861,40 12,40 L112,40 C114.209139,40 116,38.209139 116,36 L116,12 C116,9.790861 114.209139,8 112,8 Z",
    id: "Shape",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.512,25.4 C60.63634,25.4088267 59.1221391,26.9349449 59.1280167,28.8106165 C59.1338943,30.6862881 60.6576298,32.2028866 62.5333083,32.1999582 C64.4089868,32.1970298 65.9279792,30.6756808 65.928,28.8 C65.9411784,27.891499 65.5849853,27.0165678 64.9410041,26.3756029 C64.2970229,25.7346381 63.4204291,25.3825565 62.512,25.4 L62.512,25.4 Z M62.512,30.864 C61.6665819,30.9231242 60.8709384,30.4594508 60.5056171,29.6947497 C60.1402957,28.9300485 60.2795487,28.0197462 60.8567727,27.3992304 C61.4339967,26.7787146 62.3318703,26.5741059 63.1209503,26.8832665 C63.9100303,27.192427 64.4299351,27.9525195 64.432,28.8 C64.4580342,29.3301375 64.2688262,29.8483142 63.9073123,30.2369416 C63.5457984,30.6255691 63.0426337,30.8516931 62.512,30.864 L62.512,30.864 Z M55.064,25.4 C53.1872796,25.4044158 51.669062,26.9285975 51.6720042,28.8053208 C51.6749463,30.6820441 53.1979354,32.201458 55.0746604,32.1999895 C56.9513854,32.1985211 58.4719948,30.6767256 58.472,28.8 C58.4851784,27.891499 58.1289853,27.0165678 57.4850041,26.3756029 C56.8410229,25.7346381 55.9644291,25.3825565 55.056,25.4 L55.064,25.4 Z M55.064,30.864 C54.2181406,30.9264584 53.4201772,30.465097 53.0522814,29.7008773 C52.6843855,28.9366575 52.8214582,28.0251692 53.3978507,27.4029547 C53.9742432,26.7807402 54.872606,26.5744781 55.6626831,26.8829541 C56.4527601,27.1914302 56.9736972,27.9518409 56.976,28.8 C57.0020342,29.3301375 56.8128262,29.8483142 56.4513123,30.2369416 C56.0897984,30.6255691 55.5866337,30.8516931 55.056,30.864 L55.064,30.864 Z M46.192,26.448 L46.192,27.888 L49.648,27.888 C49.5938107,28.566243 49.3118757,29.2062356 48.848,29.704 C48.1488183,30.4161797 47.1812346,30.7997264 46.184,30.76 C44.0632266,30.76 42.344,29.0407734 42.344,26.92 C42.344,24.7992266 44.0632266,23.08 46.184,23.08 C47.1582366,23.0641111 48.0990096,23.4352417 48.8,24.112 L49.816,23.096 C48.8599357,22.1278865 47.5525747,21.5882033 46.192,21.6 C44.2551686,21.5246232 42.4323148,22.5149374 41.4414832,24.1808456 C40.4506516,25.8467539 40.4506516,27.9212461 41.4414832,29.5871544 C42.4323148,31.2530626 44.2551686,32.2433768 46.192,32.168 C47.577412,32.2306035 48.9221926,31.690941 49.88,30.688 C50.7181406,29.7671373 51.1656345,28.556609 51.128,27.312 C51.1305815,27.0087906 51.1037897,26.7060438 51.048,26.408 L46.192,26.448 Z M82.44,27.568 C82.0128637,26.3113681 80.8543422,25.4488424 79.528,25.4 C78.6434908,25.3982706 77.797716,25.762726 77.1915035,26.4068268 C76.585291,27.0509276 76.2727164,27.9172185 76.328,28.8 C76.3083528,29.7034369 76.6569315,30.5760227 77.2936417,31.2172593 C77.930352,31.8584958 78.8004466,32.213247 79.704,32.2 C80.8406868,32.2061272 81.9045147,31.6411564 82.536,30.696 L81.376,29.896 C81.0237968,30.4831537 80.388685,30.8417336 79.704,30.84 C78.9948731,30.8670281 78.341313,30.4577599 78.056,29.808 L82.608,27.928 L82.44,27.568 Z M77.8,28.704 C77.7672416,28.2041314 77.9370606,27.712116 78.2711733,27.3388729 C78.6052861,26.9656298 79.0755682,26.7425773 79.576,26.72 C80.1034959,26.6852413 80.6008531,26.968546 80.84,27.44 L77.8,28.704 Z M74.104,32 L75.6,32 L75.6,22 L74.104,22 L74.104,32 Z M71.656,26.16 L71.6,26.16 C71.1439697,25.6501414 70.4920458,25.359104 69.808,25.36 C67.9921175,25.4480573 66.5650697,26.9459837 66.5650697,28.764 C66.5650697,30.5820163 67.9921175,32.0799427 69.808,32.168 C70.4942632,32.179539 71.1504128,31.8866151 71.6,31.368 L71.648,31.368 L71.648,31.856 C71.648,33.16 70.952,33.856 69.832,33.856 C69.0690424,33.8381419 68.3925825,33.3608268 68.12,32.648 L66.816,33.192 C67.3181453,34.4134488 68.5113847,35.2078867 69.832,35.2 C71.584,35.2 73.032,34.168 73.032,31.656 L73.032,25.6 L71.656,25.6 L71.656,26.16 Z M69.944,30.864 C68.8743101,30.7697278 68.0539011,29.873836 68.0539011,28.8 C68.0539011,27.726164 68.8743101,26.8302722 69.944,26.736 C70.4608957,26.762526 70.9451888,26.9966161 71.2870798,27.3851972 C71.6289709,27.7737783 71.7994984,28.2839335 71.76,28.8 C71.8041078,29.3184395 71.634126,29.8323449 71.2895762,30.2222302 C70.9450265,30.6121154 70.4559283,30.8440111 69.936,30.864 L69.944,30.864 Z M89.448,22 L85.872,22 L85.872,32 L87.368,32 L87.368,28.208 L89.456,28.208 C90.6181472,28.291491 91.7295792,27.7188072 92.3361041,26.7239784 C92.942629,25.7291496 92.942629,24.4788504 92.3361041,23.4840216 C91.7295792,22.4891928 90.6181472,21.916509 89.456,22 L89.448,22 Z M89.448,26.8 L87.36,26.8 L87.36,23.392 L89.48,23.392 C90.4277206,23.392 91.196,24.1602794 91.196,25.108 C91.196,26.0557206 90.4277206,26.824 89.48,26.824 L89.448,26.8 Z M98.672,25.36 C97.5589702,25.2934712 96.5125495,25.8936704 96.008,26.888 L97.336,27.44 C97.6035246,26.9469345 98.1368998,26.6582845 98.696,26.704 C99.0796224,26.6591957 99.4651629,26.7703761 99.7660226,27.0125681 C100.066882,27.2547602 100.257839,27.6076599 100.296,27.992 L100.296,28.096 C99.815514,27.8415993 99.2796738,27.7097001 98.736,27.712 C97.304,27.712 95.856,28.512 95.856,29.96 C95.8845501,30.583767 96.1641923,31.1694636 96.6313051,31.5838379 C97.0984179,31.9982122 97.7132785,32.2060261 98.336,32.16 C99.1033833,32.2151065 99.8396552,31.8469705 100.256,31.2 L100.304,31.2 L100.304,32 L101.744,32 L101.744,28.152 C101.744,26.4 100.416,25.384 98.712,25.384 L98.672,25.36 Z M98.488,30.84 C98,30.84 97.32,30.592 97.32,29.992 C97.32,29.192 98.168,28.928 98.92,28.928 C99.3952336,28.9162735 99.8649047,29.0323099 100.28,29.264 C100.176557,30.159532 99.4292189,30.8420324 98.528,30.864 L98.488,30.84 Z M106.992,25.6 L105.28,29.936 L105.232,29.936 L103.456,25.6 L101.856,25.6 L104.52,31.664 L103,35.032 L104.56,35.032 L108.656,25.6 L106.992,25.6 Z M93.544,32 L95.04,32 L95.04,22 L93.544,22 L93.544,32 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.352,14.032 C16.091252,14.3448867 15.9596429,14.7454359 15.984,15.152 L15.984,32.848 C15.9596429,33.2545641 16.091252,33.6551133 16.352,33.968 L16.408,34.024 L26.32,24.12 L26.32,23.888 L16.408,13.976 L16.352,14.032 Z",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,27.424 L26.32,24.12 L26.32,23.888 L29.6,20.576 L29.672,20.616 L33.6,22.848 C34.72,23.48 34.72,24.52 33.6,25.16 L29.688,27.384 L29.6,27.424 Z",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.696,27.376 L26.32,24 L16.352,33.968 C16.8229742,34.3820179 17.5219432,34.4021805 18.016,34.016 L29.704,27.376",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.696,20.624 L18.008,13.984 C17.5139432,13.5978195 16.8149742,13.6179821 16.344,14.032 L26.32,24 L29.696,20.624 Z",
    id: "Shape",
    fill: "#FFFFFF",
    stroke: "#000000",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4,18.504 C42.0769542,18.51494 41.7601705,18.4131167 41.504,18.216 C41.2533378,18.0084254 41.0719364,17.7293464 40.984,17.416 L41.544,17.184 C41.6043598,17.6226468 41.981239,17.9481334 42.424,17.944 C42.6772183,17.961281 42.9236143,17.857379 43.088,17.664 C43.2518315,17.4486575 43.3340318,17.1822152 43.32,16.912 L43.32,13.6 L43.936,13.6 L43.936,16.872 C43.9668056,17.3172975 43.8101976,17.7552202 43.504,18.08 C43.2093367,18.3661562 42.8104586,18.5193485 42.4,18.504 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "47.768 14.192 45.6 14.192 45.6 15.712 47.568 15.712 47.568 16.288 45.6 16.288 45.6 17.808 47.784 17.808 47.784 18.4 44.96 18.4 44.96 13.6 47.76 13.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "50.4 18.4 49.784 18.4 49.784 14.192 48.408 14.192 48.408 13.6 51.704 13.6 51.704 14.192 50.4 14.192"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "52.216 18.4 52.216 17.76 54.768 14.192 52.32 14.192 52.32 13.6 55.52 13.6 55.52 14.24 52.968 17.808 55.552 17.808 55.552 18.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "58.032 18.4 57.416 18.4 57.416 14.192 56.08 14.192 56.08 13.6 59.376 13.6 59.376 14.192 58.032 14.192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.76,18.4 L61.76,13.6 L63.496,13.6 C63.8564484,13.5931926 64.2057765,13.7249065 64.472,13.968 C64.742625,14.2028598 64.8950178,14.5457434 64.888,14.904 C64.8917544,15.1172497 64.8303541,15.3265688 64.712,15.504 C64.5945413,15.6763448 64.4309815,15.8121827 64.24,15.896 L64.24,15.896 C64.4720537,15.9728176 64.6755698,16.1177879 64.824,16.312 C64.9778308,16.508003 65.0597268,16.7508671 65.056,17 C65.0642688,17.3733807 64.9059452,17.7310747 64.624,17.976 C64.3454432,18.2329502 63.9789323,18.3732552 63.6,18.368 L61.76,18.4 Z M62.4,15.656 L63.52,15.656 C63.7317111,15.6648381 63.9365663,15.5799695 64.08,15.424 C64.2138565,15.2904304 64.2890805,15.1090989 64.2890805,14.92 C64.2890805,14.7309011 64.2138565,14.5495696 64.08,14.416 C63.9446528,14.2629044 63.7482545,14.1778961 63.544,14.184 L62.4,14.184 L62.4,15.656 Z M62.4,17.808 L63.64,17.808 C63.859375,17.8153598 64.0705864,17.7244215 64.216,17.56 C64.3570521,17.4136999 64.4371393,17.2192024 64.44,17.016 C64.44,16.5741722 64.0818278,16.216 63.64,16.216 L62.4,16.216 L62.4,17.808 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "68.68 14.192 66.496 14.192 66.496 15.712 68.464 15.712 68.464 16.288 66.496 16.288 66.496 17.808 68.68 17.808 68.68 18.4 65.88 18.4 65.88 13.6 68.68 13.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.2,
    fill: "#FFFFFF",
    points: "69.648 18.4 69.648 13.6 70.264 13.6 70.264 18.4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadgeDe);
export default __webpack_public_path__ + "static/media/google-play-badge_de.e839a8743796903044edc7c426467393.svg";
export { ForwardRef as ReactComponent };